import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';
import getFetchOptions from 'utils/getFetchOptions';

export default function toggleFeidePortal(chosenGroup) {
	return fetch(
		`${ENDPOINT_URL}/togglefeide`,
		getFetchOptions({
			method: 'PUT',
			body: JSON.stringify({
				chosenGroup,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
